import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { HelpApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';

const HelpTextModal = ({ isOpen, submitCallback, cancelCallback, inputText = '' }) => {
    const helpApi = new HelpApi.HelpApi(applicationInsights);
    const currentRoute = window.location.pathname;

    const [helpText, set_helpText] = React.useState<string>('');

    React.useEffect(() => {
        set_helpText(inputText);
    }, [inputText]);

    const _onSubmit = async (event) => {
        event.preventDefault();

        const postNotes: HelpApi.ISavePageHelpText = {
            route: currentRoute,
            text: helpText,
        };

        await helpApi.savePageHelpText(postNotes);

        submitCallback(helpText);
    };

    const _handleClose = () => {
        cancelCallback();
    };

    const styles = {
        buttonMarginRight: {
            marginRight: '20px',
        },
        noMargin: {
            margin: 0,
        },
        sideMargin: {
            marginRight: 20,
            marginLeft: 20,
        },
        modal: {
            width: 600,
        },
        autoHeight: {
            height: 'auto',
        },
    };

    return (
        <Dialog
            maxWidth='lg'
            open={isOpen}
            onClose={_handleClose}
            aria-labelledby='form-dialog-title'
        >
            <div className='modal-container'>
                <div className='modal-backdrop'></div>
                <div
                    className='modal'
                    tabIndex={-1}
                    role='dialog'
                    style={styles.modal}
                >
                    <div
                        className='modal-dialog'
                        role='document'
                    >
                        <form
                            name='brokerForm'
                            onSubmit={(event) => _onSubmit(event)}
                        >
                            <div
                                className='page-header'
                                role='banner'
                            >
                                <h1>Edit Help Text</h1>
                                <button
                                    type='button'
                                    className='close'
                                    data-dismiss='modal'
                                    aria-label='Close'
                                    onClick={_handleClose}
                                >
                                    <span aria-hidden='true'>&times;</span>
                                </button>
                            </div>
                            <div className='main-content no-search'>
                                <div
                                    className='scrollable-content'
                                    style={styles.autoHeight}
                                >
                                    <div className='standard-form'>
                                        <div
                                            className='row'
                                            style={styles.noMargin}
                                        >
                                            <textarea
                                                name='helpText'
                                                cols={40}
                                                rows={3}
                                                className='req'
                                                style={styles.sideMargin}
                                                value={helpText}
                                                onChange={(event) => set_helpText(event.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className='button-footer'>
                                        <button
                                            style={styles.buttonMarginRight}
                                            type='submit'
                                            className='button primary'
                                        >
                                            Submit
                                        </button>
                                        <button
                                            type='button'
                                            className='button hollow'
                                            data-dismiss='modal'
                                            onClick={_handleClose}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default HelpTextModal;
